export default "__VITE_PUBLIC_ASSET__ac7dec39__"